<div class="i3-table-container">
    <div class="i3-table-wrapper">
        <toro-i3-table-card
                *ngFor="let asset of assets"
                [asset]="asset"
                [(selectedAsset)]="selectedAsset"
                (tableItemClick)="onTableItemClick($event)"
        ></toro-i3-table-card>
    </div>
</div>
